(() => {
  'use strict';
  const params = new URLSearchParams(location.search);
  // Only bounded campaign identifiers, never free-form email/phone values, enter tags.
  const tags = ['lansman-listesi', 'clemoa-sac', 'izin-v4-20261031'];
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'angle']) {
    const raw = params.get(key);
    if (raw && /^[\p{L}\p{N}_-]{1,80}$/u.test(raw)) {
      tags.push(`${key}:${raw}`);
      if (key === 'utm_campaign') tags.push(raw);
    }
  }
  document.querySelectorAll('[data-v4-tags]').forEach(input => { input.value = tags.join(','); });
  const openDisclosure = () => {
    const target = document.getElementById(location.hash.slice(1));
    if (target?.matches('details')) target.open = true;
    else if (target?.id === 'lansman-aydinlatma') target.querySelector('details').open = true;
  };
  addEventListener('hashchange', openDisclosure);
  openDisclosure();
  document.querySelectorAll('a[href="#lansman-aydinlatma"], a[href="#cerezler"]').forEach(link => link.addEventListener('click', () => {
    const target = document.querySelector(link.getAttribute('href'));
    const detail = target?.matches('details') ? target : target?.querySelector('details');
    if (detail) detail.open = true;
  }));
  const sticky = document.querySelector('.v4-sticky');
  const forms = [...document.querySelectorAll('.v4-form')];
  const visibility = new Map(forms.map(form => [form, true]));
  if (sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => visibility.set(entry.target, entry.isIntersecting));
      sticky.hidden = [...visibility.values()].some(Boolean) || !!document.querySelector('[data-v4-success]');
    });
    forms.forEach(form => observer.observe(form));
    document.addEventListener('focusin', () => { if (document.activeElement?.matches('input')) sticky.hidden = true; });
    document.addEventListener('focusout', () => { sticky.hidden = [...visibility.values()].some(Boolean) || !!document.querySelector('[data-v4-success]'); });
  }
  // Fail closed: unknown privacy status never enables tracking.
  const allowed = type => {
    try { return window.Shopify?.customerPrivacy?.[type]?.() === true; } catch { return false; }
  };
  const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const save = (key, value) => { try { sessionStorage.setItem(key, value); return true; } catch { return false; } };
  const publish = (name, data) => {
    if (!allowed('analyticsProcessingAllowed') || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    try { const result = window.Shopify.analytics.publish(name, data); result?.catch?.(() => {}); return true; } catch { return false; }
  };
  const success = document.querySelector('[data-v4-success]');
  let leadBusy = false;
  const lead = () => {
    if (!success || leadBusy || !allowed('marketingAllowed') || !allowed('analyticsProcessingAllowed')) return;
    const key = 'clemoa-v4-lead';
    let record;
    try { record = JSON.parse(read(key) || 'null'); } catch { record = null; }
    if (!record) record = { id: window.crypto?.randomUUID?.() || `clemoa-${Date.now()}-${Math.random().toString(36).slice(2)}`, meta: false, shopify: false };
    // Persistent dedup is required; storage failure suppresses Lead rather than duplicating it.
    if (!save(key, JSON.stringify(record))) return;
    leadBusy = true;
    if (!record.shopify && publish('clemoa_lead', { content_name: 'clemoa-lansman-listesi', event_id: record.id })) {
      record.shopify = true; save(key, JSON.stringify(record));
    }
    const sendMeta = () => {
      if (!allowed('marketingAllowed') || !allowed('analyticsProcessingAllowed') || record.meta) { leadBusy = false; return; }
      if (typeof window.fbq === 'function') {
        record.meta = true;
        if (save(key, JSON.stringify(record))) window.fbq('trackSingle', '1460306932099570', 'Lead', { content_name: 'clemoa-lansman-listesi' }, { eventID: record.id });
      }
      leadBusy = false;
    };
    if (record.meta) { leadBusy = false; return; }
    if (typeof window.fbq === 'function') { sendMeta(); return; }
    const fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
    fbq('init', '1460306932099570');
    const script = document.createElement('script'); script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onload = sendMeta; script.onerror = () => { leadBusy = false; };
    document.head.appendChild(script);
  };
  const seen = new Set();
  const once = (key, name, data) => {
    if (seen.has(key) || read(key)) return;
    if (publish(name, data)) { seen.add(key); save(key, '1'); }
  };
  const measure = () => {
    if (!allowed('analyticsProcessingAllowed')) return;
    const depth = (scrollY + innerHeight) / document.documentElement.scrollHeight * 100;
    [50, 90].forEach(percent => { if (depth >= percent) once(`clemoa-v4-scroll-${percent}`, 'clemoa_scroll', { percent }); });
    const rect = document.getElementById('fiyat')?.getBoundingClientRect();
    if (rect && Math.min(innerHeight, rect.bottom) - Math.max(0, rect.top) >= Math.min(rect.height, innerHeight) * 0.5) once('clemoa-v4-price-view', 'clemoa_price_view', { section: 'fiyat' });
  };
  let queued = false;
  addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; measure(); }); } }, { passive: true });
  document.addEventListener('visitorConsentCollected', () => { lead(); measure(); });
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) { lead(); measure(); } });
  lead(); measure();
})();
